// Models
import { GridsterItem } from 'angular-gridster2';
import { DashboardDto } from '../models/dashboard-dto';

export namespace DashboardActions {
	export class GetAll {
		static readonly type = '[Dashboard] Get Dashboards';
		constructor(public data: { jobKey: string; showSpinner?: boolean; showToast?: boolean } = { jobKey: null, showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[Dashboard] Set Dashboards';
		constructor(public dashboards: DashboardDto[]) {}
	}

	export class CreateDashboard {
		static readonly type = '[Dashboard] Create Dashboard';
		constructor(public data: { jobKey: string; dashboard: DashboardDto; showSpinner?: boolean; showToast?: boolean } = { jobKey: null, dashboard: null, showSpinner: false, showToast: false }) {}
	}

	export class CreateDashboardSuccess {
		static readonly type = '[Dashboard] Create Dashboard Success';
		constructor(public dashboard: DashboardDto) {}
	}

	export class CreateDashboardError {
		static readonly type = '[Dashboard] Create Dashboard Error';
	}

	export class UpdateOrCopyDashboard {
		static readonly type = '[Dashboard] Update Dashboard';
		constructor(public data: { jobKey: string; dashboard: DashboardDto; copy?: boolean; showSpinner?: boolean; showToast?: boolean } = { jobKey: null, dashboard: null, copy: false, showSpinner: false, showToast: false }) {}
	}

	export class UpdateOrCopyDashboardSuccess {
		static readonly type = '[Dashboard] Update Dashboard Success';
		constructor(public dashboard: DashboardDto) {}
	}

	export class UpdateOrCopyDashboardError {
		static readonly type = '[Dashboard] Update Dashboard Error';
	}

	export class SetCurrentDashboard {
		static readonly type = '[Dashboard] Set Current Dashboard';
		constructor(public dashboard: DashboardDto) {}
	}

	export class SetCurrentDashboardGridsterItems {
		static readonly type = '[Dashboard] Set Current Dashboard Gridster Items';
		constructor(public items: GridsterItem[]) {}
	}
}
